module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/mainvisual-title-pc@2x_6f22d70e2ef4a7fecfed2f7c7d5d50bf.png";